<template>
  <div v-if="show" class="configuration">
    <div v-if="cnt_mul === 0" class="main_config__wrap">

      <div class="main_config">
        <div class="header">
          <div class="header__left">
            <p>{{ translate('cur_ver') }}: {{ ver }}</p>
            <p>{{ translate('device.config.main') }}: </p>
          </div>
          <div class="header__right">

            <p>
              {{ translate('user.one') }}:
              <router-link
                  v-if="$store.getters.getPermissions.permissionGod === true && username !== ''"
                  :to="'/user/' + username"
              >
                {{ username }}
              </router-link>

              <span v-else>
                {{ username }}
              </span>
            </p>
            <p>
              {{ translate('config.ts') }}: {{ get_date(ts) }}
            </p>
          </div>
        </div>

        <div class="config_for_8" v-if="isV8">

          <div class="config_card" v-for="(item, key) in Object.keys(isV8_blocks_show)" :key="item + '' + key">
            <div class="card_title" @click="isV8_blocks_show[item] = !isV8_blocks_show[item]">
              {{ item }}
            </div>
            <div class="config_card__content" :class="{ 'hide_block': !isV8_blocks_show[item] }">
              <textarea
                  v-model="config[item]"
                  aria-label="main"
                  :readonly="!$store.getters.getPermissions.editDeviceConfig"
              />
            </div>
          </div>
        </div>

        <codemirror
            class="codemirror card"
            v-model="config.main"
            :options="{
            mode: 'toml',
            theme: 'neat',
            lineNumbers: true,
            tabSize: 2
          }"
        />

        <div v-if="$store.getters.getPermissions.editDeviceConfig" class="save_config">
          <div class="group_config">
            <span class="btn btn-success" @click.prevent="select_group_config" >
              {{ translate("config.select_group_config") }}
            </span>
          </div>

          <div class="buttons">
            <span
                class="mdi mdi-archive btn btn-success"
                @click.prevent="pre_save_config"
            >
              {{ translate("save") }}
            </span>

            <span
                v-if="config_history?.length > 1 && !isV8"
                class="mdi mdi-file-compare btn btn-info"
                @click.prevent="compare_config()"
            >
              {{ translate("config.compare_configs") }}
            </span>

            <span
                class="mdi mdi-file-document btn btn-success"
                @click.prevent="show_documentatiom()"
            >
              {{ translate("config.documentation") }}
            </span>
          </div>

        </div>
      </div>

      <div class="history">
        <div class="device_adresses_wrap" v-if="device_addresses.length > 0">
          <label>
            {{ translate('config.device_adresses') }}
          </label>
          <div class="device_adresses">
            <DeviceAddresses
              :device_addresses = "device_addresses"
              @update="load_conf"
            />
          </div>
        </div>

        <div class="config_history_wrap" v-if="config_history?.length > 0 || group_config_history?.length > 0">
          <div class="tab">
            <span
                class="tab_title"
                :class="{ active : block==='HistoryConfigChanges'}"
                @click="selected_block('HistoryConfigChanges')">
              {{ translate('config.history_config_changes')}}
            </span>
            <span
                class="tab_title"
                :class="{ active : block==='HistoryGroupConfig'}"
                @click="selected_block('HistoryGroupConfig')"
            >
              {{ translate('config.history_group_config')}}
            </span>
          </div>
          <div class="block">
            <HistoryConfigChanges
                v-if="block==='HistoryConfigChanges'"
                :all_data = "config_history"
                :last_version="ver"
                :dev_id="dev_id"
                :dev_fid="dev_fid"
                @update="load_conf"
            />
            <HistoryGroupConfig
                v-if="block==='HistoryGroupConfig'"
                :all_data = "group_config_history"
                :last_version="ver"
                :dev_id="dev_id"
                :dev_fid="dev_fid"
                @update="load_conf"
            />
          </div>

        </div>

        <div class="device_config_wrap" v-if="device_config.table_data?.length > 0">
          <label>
            {{ translate('config.config_synchro_history') }}
          </label>
          <div class="device_config">

            <TextTable
                :all_data = "device_config"
            />
          </div>
        </div>

      </div>
    </div>
  </div>

  <div
    v-else-if="config?.main===false"
    style="height: 100%"
  >
    {{ translate("file.no") }}
  </div>
  <div
    v-else
    style="height: 100%"
  >
    <div class="spinner">
      <scale-loader />
    </div>
  </div>
</template>

<script>
import TextTable from 'components/UIComponents/Plugins/TextTablePlagin/TextTable.vue';
import ShowDocumentation from "@/views/Dashboard/General/Documentation/Index.vue";
import CompareConfigs from "./CompareConfigs.vue";
import CompareConfigsByVer from "./CompareConfigsByVer.vue";
import DeviceAddresses from "./DeviceAddresses/Index.vue";

import ApplyGroupConfig from "./ApplyGroupConfig.vue";
import HistoryConfigChanges from "./HistoryConfigChanges/HistoryConfigChanges.vue"
import HistoryGroupConfig from "./HistoryGroupConfig/HistoryGroupConfig.vue"
import HistoryAction from "components/UIComponents/Summary/Tabs/HistoryAction/Index.vue";
import Comments from "components/UIComponents/Summary/Tabs/Comments/Index.vue";

export default {
  name: 'Configuration',
  components: {
    Comments,
    HistoryAction,
    TextTable,
    DeviceAddresses,
    HistoryConfigChanges,
    HistoryGroupConfig
  },
  props: {
    dev_fid: [Number, String], //FID
    dev_id: [Number, String] //Device ID
  },
  data () {
    return {
      show: false,
      ts: 0,
      ver: 0,
      config: {
        main: ""
      },
      start_config: {},
      isV8: false,
      isV8_blocks_show: {},
      username: '',
      multi: {},
      device_addresses: {},
      config_history: [],
      group_config_history: [],
      device_config: {},
      device_group_id: null,

      block: "HistoryConfigChanges"
    }
  },

  computed: {
    cnt_mul () {
      return 0
    },
    default_show_block(){
      return ["network", "wireless", "routeman", "modemd"]
    },
  },
  watch: {
    $route () {
      this.to_zero()
    },
    dev_fid () {
      this.show = false
      this.load_conf()
    }
  },
  mounted () {
    this.to_zero()
  },
  methods: {
    selected_block(block){
      this.block = block
    },
    select_group_config(){
      let t = this.$createElement(ApplyGroupConfig, {
        props: {
          device_fid: this.dev_fid
        },
        on: {
          close: () => {
            this.$modal.hide('apply_group_config')
          },
          next: (select_config) => {
            this.config = select_config.config
            this.device_group_id = select_config.id
            this.$modal.hide('apply_group_config')
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(
          temp,
          {},
          {
            height: 'auto',
            adaptive: true,
            clickToClose: true,
            scrollable: true,
            name: 'apply_group_config'
          }
      )
    },
    restart_page(){
      window.open('#/device/'+this.dev_fid+'/config', '_self')
    },
    to_zero () {
      let flag = true
      if (this.$route.params.to_zero === 'to_zero') {
        if (confirm('Обнулить версию конфигурации для ' + this.dev_fid + ' ?')) {
          flag = false
          this.$http.v1.resetDeviceConfigVersion(this.dev_fid, () => {
            this.load_conf()
          })
        }
        this.restart_page()
      }
      if (flag) {
        this.load_conf()
      }
    },
    load_conf () {
      this.show = false
      if (this.$route.name === 'device_section') {
        this.$http.v1.getDeviceConfig(this.dev_fid, (response) => {
          this.ver = response.data.ver
          this.config = Object.keys(response.data.config).length > 0 ? response.data.config : {main: ""}

          this.start_config = this.config.main

          this.config_history = response.data.config_history
          this.group_config_history = response.data.group_config_apply_history
          this.device_config = response.data.device_config_history
          this.device_addresses = response.data.device_addresses
          this.ts = response.data.ts
          this.username = response.data.username
          this.show = true
          this.multi = [] // Array.isArray(response.data.multi_instance) ? {} : response.data.multi_instance; this.show = true

          this.isV8 = response.data.isV8
          Object.keys(response.data.config).forEach((item) => {
            let val = (this.default_show_block.find(block => block === item))
            this.$set(this.isV8_blocks_show, item, val)
          })
        })
      }

    },
    pre_save_config(){
      let t = this.$createElement(CompareConfigs, {
        props: {
          config_1: this.start_config,
          config_2: this.config.main
        },
        on: {
          close: () => {
            this.$modal.hide('compare_configs_modal')
          },
          save: () => {
            this.save_config()
            this.$modal.hide('compare_configs_modal')
          }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(
          temp,
          {},
          {
            height: 'auto',
            width: 800,
            adaptive: true,
            clickToClose: true,
            scrollable: true,
            name: 'compare_configs_modal'
          }
      )
    },
    save_config () {
      this.show = false
      let params = {
        config: this.config
      }
      this.device_group_id !== null ? params.device_group_id = this.device_group_id : ''
      this.$http.v1.saveDeviceConfig(this.dev_fid, params, (response) => {
        this.global_notify('info', this.translate('config.saved_success'))
        this.config = response.data.config
        this.start_config = this.config.main

        this.multi = response.data.config.multi_instance
        this.ver = response.data.ver
        this.show = true
        this.config_history = response.data.config_history
        this.group_config_history = response.data.group_config_apply_history
        this.device_config = response.data.device_config_history
        this.device_addresses = response.data.device_addresses
        this.ts = response.data.ts
        this.username = response.data.username
        this.device_group_id = null

        this.isV8 = response.data.isV8
        Object.keys(response.data.config).forEach((item) => {
          this.isV8_blocks_show[item] = false
        })

      }, (bad_answer) => {
        this.bad_answer_handler(bad_answer)
        this.show = true
      })
    },
    add_multi () {
      this.multi['multi_link_' + (this.cnt_mul + 1)] = ''
      this.multi = {...this.multi}
    },
    compare_config(){
      let list_config_ver = this.config_history.map((arr) =>{
        return {id: arr.ver , label: arr.ver }
      }).filter((item, index, self) =>
          index === self.findIndex((t) => JSON.stringify(t) === JSON.stringify(item))
      );

      let t = this.$createElement(CompareConfigsByVer, {
        props: {
          dev_id: this.dev_id,
          list_config_ver
        },
        on: {close: () => {this.$modal.hide('compare_configs_modal') }}
      })
      let temp = { render () { return t } }
      this.$modal.show(
        temp,
        {},
        {
          height: 'auto',
          width: 800,
          adaptive: true,
          clickToClose: true,
          scrollable: true,
          name: 'compare_configs_modal'
        }
      )
    },
    show_documentatiom(){
      var t = this.$createElement(ShowDocumentation, {
        on: {close: () => {this.$modal.hide('show_documentation_modal') }}
      })
      let temp = { render () { return t } }
      this.$modal.show(
          temp,
          {},
          {
            width: 1100,
            height: 'auto',
            adaptive: true,
            clickToClose: true,
            scrollable: true,
            name: 'show_documentation_modal'
          }
      )
    },
  }
}

</script>

<style lang='scss' scoped>
  .configuration{
    display: flex;
    flex-direction: column;
    overflow:hidden;
    height: 100%;
    .main_config{
      flex: 10;
      height: 100%;
      overflow: auto;
      display: flex;
      flex-direction: column;
      padding-right: 10px;
      &::-webkit-scrollbar{
        width: 10px;
      }
      &__wrap{
        height: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .history{
          height: 100%;
          flex: 8;
          .config_history{
            height: calc(100% - 20px);
            &_wrap{
              height: calc(40% - 5px);
              margin-top: 5px;
              label{
                height: 20px;
                font-size: 14px;
                margin: 0;
              }
            }
          }
          .device_adresses{
            height: calc(100% - 20px);
            &_wrap{
              height: calc(20% - 5px);
              margin-top: 5px;
              label{
                height: 20px;
                font-size: 14px;
                margin: 0;
              }
            }
          }
          .device_config{
            height: calc(100% - 20px);
            &_wrap{
              height: 40%;
              margin-top: 5px;
              label{
                height: 20px;
                font-size: 14px;
                margin: 0;
              }
            }
          }
        }
      }
      .header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        p{
          margin: 0;
          font-size: 10px;
        }
        &__right{
          a{
            color: #66615b;
          }
        }
      }
      textarea{
        flex: 10;
        width: 100%;
        overflow: auto;
        font-size: 16px;
        line-height: 125%;
        &::-webkit-scrollbar{
          width: 10px;
        }
      }
    }
    .save_config{
      margin-top: 10px;
      display: flex;
      justify-content: space-between;

      .group_config{

      }

      .buttons{
        span{
          margin: 0 5px;
          &:last-child{
            margin-right: 0;
          }
          &:first-child{
            margin-left: 0;
          }
        }
      }
    }
  }

  .config_history_wrap{
    height: 100%;
    .tab{
      width: 100%;
      height: 30px;
      display: flex;
      align-content: center;
      justify-content: center;
      flex-direction: row;
      &_title{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding: 5px 0;
        cursor: pointer;
        font-weight: 600;
        font-size: 14px;
        text-align: center;
        background-color: #efe9e9;
        border: 1px solid #efe9e9;
        &.active{
          background-color: #f8f8f8;
          border-bottom: 1px solid #f8f8f8;
        }
      }
    }
    .block{
      height: 100%;
      //border: 1px solid #efe9e9;
      margin-top: -1px;
      //padding: 10px;
      overflow: auto;
      &::-webkit-scrollbar{
        width: 10px;
      }
    }
  }

  .config_for_8{
    .config_card{
      box-shadow: 0 2px 2px #ccc5b980;
      color: #252422;
      position: relative;
      border: 1px solid #ccc;
      background-color: #f8f8f8;
      margin-bottom: 10px;
      .card_title{
        display: block;
        cursor: pointer;
        text-align: left;
        padding: 5px;
        background-color: #efe9e9;
        border-bottom: 1px solid #ccc;
      }
      &__content {
        //font: 300 12px/16px "Roboto", Arial, sans-serif;
        text-align: left;
        overflow: hidden;
        opacity: 1;
        transition: all 0.3s;
        height: 400px;

        &.hide_block {
          opacity: 0;
          height: 0;
          border: none;
          padding: 0;
        }

        textarea{
          resize: none;
          height: 100%;
        }
      }
    }
  }

  @media (max-width: 1400px) {
    .configuration{
      .main_config{
        width: 100%;
        height: 90%;
        &__wrap{
          display: block;
          overflow: auto;
          padding-right: 10px;
          &::-webkit-scrollbar{
            width: 10px;
          }
          .history{
            height: inherit;
            width: 100%;
            .config_history{
              height: 90%;
              &_wrap{
                height: 70%;
              }
            }
            .device_config{
              height: 90%;
              &_wrap{
                height: 70%;
              }
            }
          }
        }
        textarea{
          height: 100%;
        }
      }
    }
  }
  .codemirror{
    height: calc(100% - 80px);
    padding-bottom: 0;
  }

</style>
